// Single source of truth lives on the server (deploy ships server/, not src/).
// Webpack resolves this at build time for the Vue bundle.
module.exports = require('../../server/utils/dateUtils')
